var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28.621 10 0 10 0 8 28.586 8 23.293 2.707 22.586 2 24 .586 24.707 1.293 31.017 7.603 31.036 7.586 32.45 9 32.432 9.018 32.45 9.036 31.036 10.45 31.018 10.432 24.708 16.742 24 17.45 22.586 16.036 23.293 15.329 28.62 10",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrow);
export default __webpack_public_path__ + "static/media/ic_arrow.d06866fd70d8ec5dd6f2be93d2d451ee.svg";
export { ForwardRef as ReactComponent };